import { render } from "./authority-list.vue?vue&type=template&id=f9a9b0e0&scoped=true"
import script from "./authority-list.vue?vue&type=script&lang=js"
export * from "./authority-list.vue?vue&type=script&lang=js"

import "./authority-list.vue?vue&type=style&index=0&id=f9a9b0e0&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9a9b0e0"]])

export default __exports__